.button {
  height: 2.8rem;
  min-height: 2.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background-color: var(--color-surface-primary);
  border-radius: var(--spacing-radius-sm);
  border: 0.1rem solid var(--color-stroke-default);
  font-size: 1.4rem;
  font-weight: 400;
  overflow: hidden;
  padding: 0 var(--spacing-gap-sm);
  color: var(--color-texts-low-contrast);
  gap: .6rem;
  user-select: none;
  width: fit-content;

  &:hover {
    cursor: pointer;
    border-color: var(--color-stroke-hover);
    background: linear-gradient(180deg, var(--colors-surface-tertiary, #25262C) 0%, var(--colors-surface-Primary, #14141A) 100%);

  }

  &[data-is-active='true'] {
    background-color: var(--color-surface-primary);
    color: var(--color-grayscale-white);
  }

  &[data-is-disabled] {
    cursor: default;
  }
}
